import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExitButtonComponent } from '../../../../shared/components/buttons/exit-button/exit-button.component';

@Component({
  selector: 'app-trip-details',
  standalone: true,
  imports: [CommonModule, ExitButtonComponent],
  templateUrl: './trip-details.component.html',
  styleUrl: './trip-details.component.scss'
})
export class TripDetailsComponent {
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
